import type { AgentSubscription } from "schemas/agent-billing";

import { useLocalStorageState } from "@v2/hooks/useLocalStorage";
import { z } from "zod";

// Debug toggle (admin panel) that forces the v2 billing UI onto a custom-contract subscription; read by useAgentBillingSubscription. (yuxin, 2026-07-14, REPL-29329)
const MOCK_CUSTOM_PRICING_STORAGE_KEY =
  "replo.debug.agentBilling.mockCustomPricing";

export function useMockCustomPricingEnabled() {
  return useLocalStorageState(MOCK_CUSTOM_PRICING_STORAGE_KEY, false, {
    schema: z.boolean(),
  });
}

// Off-catalog Pro subscription (mirrors the settings miniapp fixture) with hasCustomPricing true. (yuxin, 2026-07-14, REPL-29329)
export const MOCK_CUSTOM_PRICING_SUBSCRIPTION: AgentSubscription = {
  id: "sub_mock_custom_pricing",
  stripeSubscriptionId: "sub_mock_custom_KEO2",
  stripeCustomerId: "cus_mock_custom_KEO2",
  status: "active",
  startedAt: new Date("2026-01-01T00:00:00.000Z"),
  cancelAt: null,
  currentPeriodEnd: new Date("2027-01-01T00:00:00.000Z"),
  interval: "year",
  plan: "pro",
  amount: 848_400,
  currency: "usd",
  hasCustomPricing: true,
  items: [
    {
      id: "si_mock_custom_pro",
      stripePriceId: "price_mock_custom_contract_pro",
      stripeProductId: "prod_mock_pro",
      unitAmount: 848_400,
      quantity: 1,
      productType: "pro",
      currency: "usd",
    },
  ],
};
